import { render, staticRenderFns } from "./RoomUsage.vue?vue&type=template&id=381c698c&"
import script from "./RoomUsage.vue?vue&type=script&lang=js&"
export * from "./RoomUsage.vue?vue&type=script&lang=js&"
import style0 from "./RoomUsage.vue?vue&type=style&index=0&id=381c698c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QIcon})
